<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Onboarding'" :showBtn="failRequest" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum onboarding encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de onboarding ({{ dataList.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> NOTA DO ADM</th>
                        <th> REALIZOU TESTE ANTES?</th>
                        <th> TOTAL DE NPS RESPONDIDO</th>
                        <th> COMENTÁRIO</th>
                        <th> NOTA TOTAL</th>
                        <th> DATA DE CADASTRO</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataList">
                        <td>
                          <a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contextCode" target="_blank"
                             class="link">{{ c.companyName }}</a>
                        </td>
                        <td>{{ c.adminRating }}</td>
                        <td>{{ c.companyTestedBefore }}</td>
                        <td>{{ c.totalNpsAnswered }}</td>
                        <td>{{ c.notes }}</td>
                        <td>{{ c.npsSum }}</td>
                        <td>{{ c.companyCreatedAt | formatDate }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  GET_ONBOARDINGS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "listOnboarding",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loadingList: false,
      failRequest: false,
      dataList: ''
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      this.failRequest = false;

      REQUEST_SERVICE.get(GET_ONBOARDINGS).then((response) => {
        UTIL_SERVICE.console("RESULT GET_ONBOARDINGS:", response.data);

        this.dataList = response.data;
        this.loadingList = false;
      }).catch((reason) => {
        this.failRequest = true;
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/onboarding/listOnboarding.vue